import api from './client';

export const getMe          = ()      => api.get('/users/me');
export const updateMe       = (data)  => api.patch('/users/me', data);
export const uploadAvatar   = (form)  => api.post('/users/me/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteAvatar   = ()      => api.delete('/users/me/avatar');
export const deleteAccount  = (data)  => api.delete('/users/me', { data });
export const getUploadToken      = ()  => api.get('/users/me/upload-token');
export const generateUploadToken = ()  => api.post('/users/me/upload-token');
export const revokeUploadToken   = ()  => api.delete('/users/me/upload-token');
